import { useQueryParam } from 'labguard-cdk'
import useAccountId from './useAccountId'

/**
 * Provide an user ID state and updater
 * Currently stored in query params
 * Default to connected user ID
 */
export default function useSelectedUserId() {
  const accountId = useAccountId()
  const [value = accountId, onChange] = useQueryParam('userId')
  return [value, onChange]
}
